<template>
  <div class="image-box-grid">
    <div
      :class="{
        'left-icon-position': !isRightSide,
        'right-icon-position': isRightSide,
      }"
    >
      <svg class="default-icon icon-display" aria-hidden="true">
        <use href="#icon-icon"></use>
      </svg>
    </div>
    <img :src="imgURL" alt="image!!!" class="image-position" />
  </div>
</template>

<script>
export default {
  name: 'imageBox',
  data() {
    return {
      test: 'test1.png',
    }
  },
  props: {
    imgURL: {
      type: String,
      default: '/pic/test1.png',
    },
    sidePosition: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    isRightSide: function () {
      return this.sidePosition !== 'left'
    },
  },
}
</script>

<style scoped>
.image-box-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  width: 100%;
}

.image-position {
  width: 100%;
  grid-column: 1 / 3;
  grid-row: 1 /2;
}

.left-icon-position {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.right-icon-position {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  z-index: 10;
  display: flex;
}

.default-icon {
  width: 2em;
  height: 2em;
  vertical-align: -0.15em;
  fill: currentColor;
}

.icon-display {
  color: var(--page-background-color);
}
</style>
